import React, { FC, useEffect, useState } from "react";
import { Select } from "antd";
import { InputStatus } from "antd/lib/_util/statusUtils";
import { useIntl } from "react-intl";
import { extractTranslation } from "../../../../helpers/formatters";
import { useRouter } from "next/router";
import { Maybe } from "graphql/jsutils/Maybe";
import { useSearchFormOptionsLazyQuery } from "../../../../src/generated/graphql";

interface SurveyUnitOptionSelectProps {
  clinicId: string;
  enabled: boolean;
  selectedOptionId?: Maybe<string>;
  setSelectedOption: (option: Maybe<string> | undefined) => void;
  datasetId?: Maybe<string> | undefined;
  status?: InputStatus;
  displayMode?: boolean;
}

export const SurveyUnitOptionSelect: FC<SurveyUnitOptionSelectProps> = ({
  clinicId,
  enabled,
  selectedOptionId,
  setSelectedOption,
  datasetId,
  status,
  displayMode,
  ...props
}) => {
  const { formatMessage } = useIntl();
  const locale = useRouter().locale;

  const [unitTitle, setUnitTitle] = useState<string | undefined>();

  const [
    searchSurveyDatasetQuery,
    { data: surveyDataset, loading: unitDatasetLoading },
  ] = useSearchFormOptionsLazyQuery({
    // fetchPolicy: 'no-cache',
  });
  const searchSurveyDataset = (searchTerm: Maybe<string> | undefined) => {
    if (datasetId) {
      searchSurveyDatasetQuery({
        variables: {
          clinicId,
          formDatasetId: datasetId,
          query: searchTerm,
        },
      });
    }
  };

  useEffect(() => {
    searchSurveyDataset("");
  }, []);

  const options =
    surveyDataset?.searchFormOptions?.response?.optionGroups
      ?.flatMap((optionGroup) => optionGroup?.options ?? [])
      ?.filterPresent()
      ?.filter((option) => {
        return option.id !== null && option.id !== undefined;
      }) ?? [];

  useEffect(() => {
    setUnitTitle(
      extractTranslation(
        options.find((o) => o.id === selectedOptionId)?.title,
        locale
      )
    );
  }, [selectedOptionId, options]);

  const getDisplayValue = () => {
    return <>&nbsp;{unitTitle || "-"}</>;
  };

  return !displayMode ? (
    <Select<string | undefined>
      status={status}
      disabled={!enabled}
      dropdownMatchSelectWidth={false}
      allowClear
      value={selectedOptionId || undefined}
      onChange={(v) => {
        setSelectedOption(v);
      }}
      placeholder={formatMessage({ id: "knowledge-input.select" })}
      style={{ width: "100%" }}
      {...props}
    >
      {options.map((option) => (
        <Select.Option key={option!.id!} value={option!.id!}>
          {extractTranslation(option?.title, locale)}
        </Select.Option>
      ))}
    </Select>
  ) : (
    getDisplayValue()
  );
};
